import React, { FC } from 'react';
import moment from 'moment';
import './App.css';
import SkladonTheme from './themes/default';
import { ThemeProvider } from '@mui/material/styles';
import AppContainer from './containers/AppContainer';
import { RawIntlProvider, createIntlCache, createIntl } from 'react-intl';
import { getLang, langsObjectMoment } from './translate';
import intlMessages from './intl';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import AdapterMoment from '@date-io/moment';

require('moment/min/locales.min');

const locale = getLang();

const cache = createIntlCache();

moment.updateLocale('en', {
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY HH:mm',
        LLLL: 'dddd, MMMM D, YYYY HH:mm',
        l: 'M/D/YYYY',
        ll: 'MMM D, YYYY',
        lll: 'MMM D, YYYY HH:mm',
        llll: 'ddd, MMM D YYYY HH:mm',
    },
});

moment.locale(langsObjectMoment[locale]);

const intl = createIntl(
    {
        locale,
        messages: intlMessages[locale],
    },
    cache
);

const App: FC = () => {
    return (
        <ThemeProvider theme={SkladonTheme}>
            <RawIntlProvider value={intl}>
                <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={langsObjectMoment[locale]}>
                    <AppContainer />
                </LocalizationProvider>
            </RawIntlProvider>
        </ThemeProvider>
    );
};

export default App;
